import { jsxs as m, jsx as r } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import { IressCheckboxStyles as e } from "./CheckboxMark.types.js";
import { c as n } from "../../index-2QXL0WYc.js";
const k = ({ checked: s, indeterminate: o, className: a, ...c }, t) => /* @__PURE__ */ m(
  "svg",
  {
    ref: t,
    className: n(a, e.checkboxMark, {
      [e.indeterminate]: o,
      [e.checked]: s
    }),
    ...c,
    version: "1.1",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ r(
        "line",
        {
          className: e.indeterminateMark,
          x1: "30",
          y1: "100",
          x2: "170",
          y2: "100"
        }
      ),
      /* @__PURE__ */ r(
        "polyline",
        {
          className: e.checkedMark,
          points: "30 95 80 142 170 50"
        }
      )
    ]
  }
), d = i(k);
export {
  d as IressCheckboxMark
};
